/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
`
export default function InquiryIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22.003" height="22" viewBox="0 0 22.003 22" css={Color}>
      <g id="그룹_6737" data-name="그룹 6737" transform="translate(-2974.999 -5902)">
        <rect id="사각형_6317-7" data-name="사각형 6317-7" width="22" height="22" transform="translate(2975 5902)" opacity="0"/>
        <path id="빼기_55" data-name="빼기 55"
              d="M355.253,509.259a8.109,8.109,0,0,1-7.258-4.507,7.5,7.5,0,0,0,1.13.088c.21,0,.423-.009.634-.028a6.67,6.67,0,0,0,.836,1.017,6.551,6.551,0,0,0,4.658,1.93,6.626,6.626,0,0,0,3.156-.8l.227-.124,2.736.455-.456-2.735.123-.228a6.591,6.591,0,0,0-1.125-7.808,6.494,6.494,0,0,0-4.03-1.9,7.392,7.392,0,0,0-.88-1.525h.254a8.089,8.089,0,0,1,7.224,11.723l.4,2.427a1.361,1.361,0,0,1-1.12,1.564h0a1.865,1.865,0,0,1-.223.017,1.591,1.591,0,0,1-.218-.017l-2.43-.4A8.171,8.171,0,0,1,355.253,509.259Z"
              transform="translate(2633.658 5413.554)"/>
        <path id="패스_6138" data-name="패스 6138" d="M349.418,505.592a8.028,8.028,0,0,1-3.629-.869l-2.427.4a1.437,1.437,0,0,1-.444,0,1.361,1.361,0,0,1-1.12-1.563l.4-2.428a8.07,8.07,0,1,1,7.215,4.455Zm-3.372-2.433.227.124a6.591,6.591,0,1,0-2.63-2.631l.123.228-.457,2.743Z" transform="translate(2633.658 5413.554)"/>
        <path id="패스_6072" data-name="패스 6072" d="M349.433,499.523a.609.609,0,0,1-.609-.609h0v-1.8a.608.608,0,0,1,.609-.609h0a.924.924,0,1,0-.924-.924h0a.609.609,0,0,1-1.219,0,2.142,2.142,0,1,1,2.752,2.054v1.274a.61.61,0,0,1-.6.614Z" transform="translate(2633.658 5413.554)"/>
        <path id="패스_6073" data-name="패스 6073" d="M349.429,501.55a.609.609,0,1,0-.609-.609A.616.616,0,0,0,349.429,501.55Z" transform="translate(2633.658 5413.554)"/>
      </g>
    </svg>
  )
}
